import { get } from '.';

export function GetTelematicAlerts(options = {}) {
	return get<any>("/app/api/telematic_alerts", options);
}